import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for the change event from the single select component
    const hiddenInput = this.element.querySelector('input[name="valuation_firm"]');
    if (hiddenInput) {
      this.hiddenInput = hiddenInput;
      this.boundChangeFirm = this.changeFirm.bind(this);
      this.hiddenInput.addEventListener('change', this.boundChangeFirm);
    }
  }

  disconnect() {
    if (this.hiddenInput && this.boundChangeFirm) {
      this.hiddenInput.removeEventListener('change', this.boundChangeFirm);
    }
  }

  changeFirm(event) {
    const firmId = event.target.value;
    const url = new URL(window.location.href);

    if (firmId) {
      // Redirect to same page with valuation_firm_id param
      url.searchParams.set('valuation_firm_id', firmId);
    } else {
      // If cleared, remove the valuation_firm_id param
      url.searchParams.delete('valuation_firm_id');
    }

    Turbo.visit(url.toString());
  }
}
